// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".inner-container[data-v-2196bf3c]{display:flex;flex-direction:column;align-items:center;justify-content:center}.divider[data-v-2196bf3c]{width:500px;max-width:100%;height:1px;background-color:#d8d8d8}.grid[data-v-2196bf3c]{display:flex;justify-content:space-around;flex-wrap:wrap;width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
